module.exports = __webpack_public_path__ + "static/media/pieChart.b714b4a6.png";